/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type GetQuickCoverQueryVariables = Exact<{
  context: Types.ZalamoObject;
  contextId: string;
}>;

export type GetQuickCoverQuery = {
  quickCover: {
    quickCoverId: string | null;
    cover: {
      coverSetupId: string | null;
      file: string | null;
      x: number | null;
      y: number | null;
      size: { h: number | null; w: number | null } | null;
    } | null;
  } | null;
};

export const GetQuickCoverDocument = gql`
  query GetQuickCover($context: ZalamoObject!, $contextId: ID!) {
    quickCover(contextId: $contextId, context: $context) {
      cover {
        coverSetupId
        file
        size {
          h
          w
        }
        x
        y
      }
      quickCoverId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetQuickCoverGQL extends Apollo.Query<
  GetQuickCoverQuery,
  GetQuickCoverQueryVariables
> {
  document = GetQuickCoverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
